// extracted by mini-css-extract-plugin
export default {"grid_wrapper":"Grid_grid_wrapper__Zd9eI","grid":"Grid_grid__D4WSN","floatingGuide_wrapper":"Grid_floatingGuide_wrapper__CygdS"};